import { DistributorEmployee, DistributorProfile } from "creso-core/types";

export function EmployeePortfolioSummary({
  employee,
  distributorProfile,
}: {
  employee: DistributorEmployee;
  distributorProfile: DistributorProfile;
}) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-sm font-semibold">
        Generated by {employee.name}
      </span>
      <span className="text-xs text-muted-foreground">
        {`ARN ${distributorProfile?.arn_code}`} | {employee?.phone_number}
      </span>
      <span className="text-xs text-muted-foreground">
        AMFI registered Mutual Fund Distributor
      </span>
    </div>
  );
}
